import axios from 'axios';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  state: {
    countries: undefined,
  },

  mutations: {
    SET_COUNTRIES(state, countries) {
      state.countries = countries;
    },
  },

  getters: {
    countries: state => state.countries,
  },

  actions: {
    getCountries: ({ commit }) => {
      axios.get(`${BASE_API}/countries`).then((r) => {
        commit('SET_COUNTRIES', r.data);
      });
    },
  }
};



// WEBPACK FOOTER //
// /src/store/modules/countries.js